// extracted by mini-css-extract-plugin
module.exports = {"articleSelect":"FilterContainerLight_articleSelect__3_ZfK","articleSelectTitle":"FilterContainerLight_articleSelectTitle__3b_9k"};